import React from 'react';
import TriangleShape from './TriangleShape'
import botIcon from "../../assets/images/icon_robot.svg"
import errorIcon from "../../assets/images/icon_failederror.svg"
import infoIcon from "../../assets/images/icon_information.svg"
import UMCModal from '../common/UMCModal'
import { ERROR_RED, DARK, BUBBLE_BGND } from "../../styles/styleUtils"

// CustomDialog display the dialog according to the given type. The footer has to be passed to allow some specific buttons.
// type = "Error" :  Displays an error dialog
// type = "Bubble": Displays a message representing a bubble spoken by the bot
// type = "Info" : Display a info message or question
// type = "Empty" : Define the own content
const CustomDialog = (props) => {
    let title = props.title ?   <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: '0px', color: DARK }}>
                                    {(props.type !== "Empty") ? ((props.type === "Error") ? <img src={errorIcon} style={{ height: '48px', marginBottom: '16px' }} alt="error icon" /> : <img src={infoIcon} style={{ height: '48px', marginBottom: '16px' }} alt="info icon" />) : <></>}
                                    {props.title}
                                </div> : "";
    let message = props.type !== "Bubble" ? ((props.type !== "Empty") ? <div style={{color: (props.type === "Error") ? ERROR_RED : DARK, textAlign: 'center', marginBottom: '30px'}}>{props.children}</div> : props.children) : 
                                            <div style={{ display: 'grid', gridTemplateColumns: '40px 15px auto', alignItems: 'center', justifyItems: 'stretch', textAlign: 'justify', margin: '10px 0 20px 0' }}>
                                                <div style={{marginTop: '10px', justifySelf: 'center'}}><img src={botIcon} style={{ height: '36px' }} alt="bot icon" /></div>
                                                <div><TriangleShape /></div>
                                                <div style={{padding: '10px', backgroundColor: BUBBLE_BGND}}>{props.children}</div>
                                            </div>;
    let customFooter = <div className="sip-modal-footer">{props.footer}</div>;

    return (
        <UMCModal
            open={props.open}
            title={title}
            onOk={props.onOk}
            onCancel={props.onCancel}
            okText={props.okText}
            cancelText={props.cancelText}
            okButtonProps={props.okButtonProps}
            cancelButtonProps={props.cancelButtonProps}
            footer={props.footer !== undefined ? customFooter: undefined}
            width={props.width !== undefined ? props.width : "400px"}
            closable={props.closable === undefined ? true : props.closable}
        >
            {message}
        </UMCModal>
    );
}

export default CustomDialog